// Keys for values the app keeps in localStorage. One definition, shared by the app and the client,
// so the same setting can't end up under two different keys.
export const configKeys = {
    locale: "openchat_locale",
    profile: "openchat_profile",
    primeCacheLimit: "openchat_prime_cache_limit",
    primeCacheBatchSize: "openchat_prime_cache_batch_size",
    lastCryptoSent: "openchat_lastcryptosent_v2",
    fontSize: "openchat_font_size",
    enterSend: "openchat_entersend",
    chitPopup: "openchat_chit_popup",
    hideChitIcon: "openchat_hide_chit_icon",
    disableChit: "openchat_disable_chit",
    showHomeScreenPrompt: "openchat_show_home_screen_prompt",
    confirmMessageDeletion: "openchat_confirm_message_deletion",
    userInfoSection: "openchat_userinfo_section",
    appearanceSection: "openchat_appearance_section",
    chatsSection: "openchat_chats_section",
    restrictedSection: "openchat_restricted_section",
    videoSection: "openchat_video_section",
    accountSection: "openchat_account_section",
    referralSection: "openchat_referral_section",
    storageSection: "openchat_storage_section",
    verificationSectionOpen: "openchat_verification_section",
    accountsSectionOpen: "openchat_accounts_section",
    bridgedAccountsSectionOpen: "openchat_bridged_accounts_section",
    userStatsSection: "openchat_user_stats_section",
    userAdvancedSection: "openchat_user_advanced_section",
    userDeleteAccountSection: "openchat_user_delete_account_section",
    groupInfoSection: "openchat_group_info_section",
    groupVisibilitySection: "openchat_group_visibility_section",
    groupRulesSection: "openchat_group_rules_section",
    groupPermissionSection: "openchat_group_permission_section",
    groupStatsSection: "openchat_group_stats_section",
    groupInviteUsersSections: "openchat_group_invite_users_section",
    groupAdvancedSection: "openchat_group_advanced_section",
    theme: "openchat_theme",
    scrollStrategy: "openchat_scrollstrategy",
    selectedAuthProvider: "openchat_selected_auth_provider",
    selectedAuthEmail: "openchat_selected_auth_email",
    userCreated: "openchat_user_created",
    lowBandwidth: "openchat_lowbandwidth",
    renderPreviews: "openchat_renderpreviews",
    utcMode: "openchat_utc_mode",
    videoCameraOn: "openchat_video_cameraon",
    videoMicOn: "openchat_video_micon",
    videoSpeakerView: "openchat_video_speaker_view",
    dclickReply: "openchat_dclickreply",
    shownAirdropPrompt: "openchat_shown_airdrop_prompt",
    exploreGroupsDismissed: "openchat_discover_hot_groups_dismissed",
    communityVisibilitySection: "openchat_community_visibility_section",
    communityRulesSection: "openchat_community_rules_section",
    communityPermissionSection: "openchat_community_permission_section",
    communityStatsSection: "openchat_community_stats_section",
    communityAdvancedSection: "openchat_community_advanced_section",
    communityInviteUsersSections: "openchat_community_invite_users_section",
    referredUsersOpen: "openchat_referred_users_section",
    browseChannels: "openchat_browse_channels",
    hideTokenBalances: "openchat_hide_token_balances",
    walletCurrency: "openchat_wallet_currency",
    linkDeviceSection: "link_account_with_native_app",
    chatListFilter: "openchat_chat_list_filter",
    softDisabled: "openchat_softdisabled",
    hideBlocked: "openchat_hideblocked",
    minLogLevel: "openchat_min_log_level",
    webRightColumnOpen: "openchat_web_right_column_open",
    webRailExpanded: "openchat_web_rail_expanded",
    unrulyColours: "openchat_unruly_colours",
    webAccent: "openchat_web_accent",
};
